export default "__VITE_ASSET__DuLuyusN__"